import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo, useEffect, useMemo } from 'react';
import { __MANAGEMENT_API_URL__ } from 'shell/constants/environment';
import { ItemVM } from 'shell/view-models/item';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { Profile } from 'shell/models/profile';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';
interface ListProfileProps {
  disabled: boolean;
  value: string;
  required?: boolean;
  onChange: (event: SelectChangeEvent<string>) => void;
  errors?: boolean;
}

const MemoizedListProfile = ({
  disabled,
  onChange,
  required,
  value,
  errors,
}: ListProfileProps): React.ReactElement => {
  const {
    data,
    error,
    get: getProfiles,
  } = useHttpFetch<HttpResponseList<Profile>>(`${__MANAGEMENT_API_URL__}/profili`, {
    data: {
      payload: {
        list: [],
      },
    },
  });

  const profiles: Array<ItemVM> = useMemo(() => {
    if (!!error || !data?.payload) {
      return [];
    }
    return data?.payload.list.map((profile) => ({
      id: profile.key.codice.toString(),
      value: profile.nome,
    }));
  }, [data, error]);

  useEffect(() => {
    getProfiles();
  }, []);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={errors} id="profile-label">
        {required ? 'Profili *' : 'Profili'}
      </InputLabel>
      <PmiSelect
        labelId="profile-label"
        id="profile"
        name="profile"
        value={value}
        label={required ? 'Profili *' : 'Profili'}
        onChange={onChange}
        disabled={disabled}
        error={errors}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {profiles
          .sort((a, b) => a.value?.localeCompare(b.value))
          .map((profile: ItemVM) => (
            <MenuItem key={profile.id} value={profile.id}>
              {profile.value}
            </MenuItem>
          ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

MemoizedListProfile.displayName = 'List Profiles component';

const ListProfile = memo(MemoizedListProfile);

export default ListProfile as typeof MemoizedListProfile;
